import { Navbar2Element } from '@typedream/core';
import {
  findNode,
  getChildren,
  isFirstChild,
  moveNodes,
  removeNodes,
  TNodeEntry,
} from '@udecode/plate-core';
import { ELEMENT_NAVBAR } from '../../../pluginKeys';
import { DreamEditor } from '../../../types';

// why do transformation happened when normalizing the node?
export const normalizeNavbar = (
  editor: DreamEditor,
  entry: TNodeEntry<Navbar2Element>,
) => {
  const [, path] = entry;

  // finding node using this method will return the node and its path
  const rootNodeEntry = findNode(editor, { match: { type: 'root' } });
  if (!rootNodeEntry) {
    return false;
  }

  const rootNodeChildren = getChildren(rootNodeEntry);

  if (
    rootNodeChildren.length !== 0
    && rootNodeChildren[0][0].type !== ELEMENT_NAVBAR
  ) {
    // root node has children and the first child isn't a navbar
    const [, firstRootChildPath] = rootNodeChildren[0];

    moveNodes(editor, {
      at: path,
      to: firstRootChildPath,
    });

    return true;
  }

  if (
    rootNodeChildren[0][0].type === ELEMENT_NAVBAR
    && !isFirstChild(path)
  ) {
    // first node is a navbar and it's current node is not the first node
    removeNodes(editor, { at: path });
    return true;
  }

  return false;
};
